import { faCoins } from '@fortawesome/pro-light-svg-icons';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { IconBox, Link } from '~/common/components';
import { routes } from '~/constants';
import { useNavigation } from '../../../context';

export const CreditOfferMenu = () => {
  const { isMenuCollapsed } = useNavigation();

  return (
    <div className="border border-solid border-other-300 rounded-md bg-text-100">
      {isMenuCollapsed ? <CreditOfferMenuCollapsed /> : <CreditOfferMenuExpanded />}
    </div>
  );
};

const CreditOfferMenuCollapsed = () => {
  return (
    <div className="flex px-2 py-[12px]">
      <Link.Base
        to={routes.profile.billing.credits}
        className="text-text-500 hover:text-primary-400 transition-colors duration-300"
        data-tt="Buy credit pack"
        data-tt-placement="right"
      >
        <IconBox size="s" icon={faCoins} />
      </Link.Base>
    </div>
  );
};

const CreditOfferMenuExpanded = () => {
  return (
    <div className="p-2">
      <p className="font-brand-b3 text-text-400 mb-[12px]">Save up to 10% on your orders!</p>
      <Link size="m" color="navy" to={routes.profile.billing.credits} endIcon={faChevronRight}>
        Buy credit pack
      </Link>
    </div>
  );
};
